import React, { useState, useEffect, useCallback } from 'react';
import { useLang } from '../context/LangContext';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';
import './PageCommon.css';

function buildAnalyticsStats(dashboardPayload, user) {
  const d = dashboardPayload?.data;
  const s = d?.stats || {};

  return {
    totalChats: s.totalConversations ?? '—',
    todayMessages: s.messagesToday ?? '—',
    activeProfiles: s.activeInstances ?? '—',
    totalContacts: d?.user?.contact ?? user?.contact ?? '—',
    aiTokens: d?.aiTokens,
  };
}

export default function Analytics() {
  const { lang } = useLang();
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchDashboard = useCallback(() => {
    return api.get('/user/get_dashboard')
      .then(r => { if (r.data?.success) setStats(buildAnalyticsStats(r.data, user)); })
      .catch(() => {});
  }, [user]);

  useEffect(() => {
    setLoading(true);
    fetchDashboard().finally(() => setLoading(false));
  }, [fetchDashboard]);

  const cards = [
    { label: { en: 'Total conversations', es: 'Conversaciones totales' }, value: stats?.totalChats ?? '—', icon: '💬' },
    { label: { en: 'Messages today', es: 'Mensajes hoy' }, value: stats?.todayMessages ?? '—', icon: '📨' },
    { label: { en: 'Active profiles', es: 'Perfiles activos' }, value: stats?.activeProfiles ?? '—', icon: '📱' },
    { label: { en: 'Total contacts', es: 'Contactos totales' }, value: stats?.totalContacts ?? '—', icon: '👥' },
    {
      label: { en: 'AI tokens', es: 'Tokens IA' },
      value: stats?.aiTokens
        ? `${stats.aiTokens.used.toLocaleString()} / ${stats.aiTokens.limit.toLocaleString()}`
        : '—',
      icon: '🧠',
    },
  ];

  return (
    <div className="page">
      <div className="page__header">
        <div>
          <h1>{lang === 'en' ? 'Analytics' : 'Analíticas'}</h1>
          <p>{lang === 'en' ? 'Track your WhatsApp performance and AI activity' : 'Monitorea el rendimiento de tu WhatsApp y actividad de la IA'}</p>
        </div>
      </div>

      {loading ? (
        <div className="page__loading"><div className="spinner" /></div>
      ) : (
        <>
          <div className="analytics__cards">
            {cards.map((c, i) => (
              <div className="analytics__card" key={i}>
                <span className="analytics__icon">{c.icon}</span>
                <div>
                  <span className="analytics__value">{c.value}</span>
                  <span className="analytics__label">{c.label[lang] || c.label.en}</span>
                </div>
              </div>
            ))}
          </div>

          <div className="page__empty page__empty--spaced">
            <span className="page__empty-icon">📊</span>
            <h3>{lang === 'en' ? 'Detailed analytics coming soon' : 'Analíticas detalladas próximamente'}</h3>
            <p>{lang === 'en' ? 'Charts, trends, peak hours, and AI vs Human response breakdown will appear here as you use the platform.' : 'Gráficos, tendencias, horas pico, y desglose IA vs Humano aparecerán aquí mientras uses la plataforma.'}</p>
          </div>
        </>
      )}
    </div>
  );
}
